import React, { Component } from 'react'
import { app, api, config } from '../../../app'
// import PDF from 'react-pdf-js';

class Verification extends Component {
    // 组件内部
    constructor(props) {
        super(props)

        let urlInfo = props.location.search
        // console.log(urlInfo)
        let codeArr = urlInfo.split('?code=')
        let code = codeArr[1]
        // console.log(code)
        this.state = {
            code: code,
            url: '',
            flag: true
        }

    }

    componentDidMount() {
        app.post(api.TeamApplyCheckFile, { code: this.state.code }).then(res => {
            if (res.flag == 1) {
                // console.log(res)

                if (res.data.valid) {
                    this.setState({
                        url: res.data.url,
                        flag: res.data.valid,
                    })
                    window.location.href= config.imgUrl + res.data.url
                } else {
                    this.setState({
                        flag: res.data.valid,
                    })
                    app.alert('无效文件', 'error', '45%')
                }
            } else {
                app.alert(res.msg, 'error', '45%')
            }
        })
    }



    // 页面渲染区
    render() {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-around',lineHeight:30,color:'red' }}>
                {!this.state.flag ? '无效文件'   : ''}
            </div>

        )
    }
}



export default Verification



// WEBPACK FOOTER //
// ./src/routes/teamApplication/PreparatoryTeamApplicationDirectory/Verification.jsx